'use client'

import { ChallengeTheme } from '@/types/Event'
import { isEmpty, map } from 'lodash'
import React, { useState } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

const ChallengeThemeSelection = ({ data, onServer }: {
  data: ChallengeTheme[]
  onServer?: boolean
}) => {
  const pathname = usePathname()
  const { replace } = useRouter()
  const [currentTheme, setCurrentTheme] = useState<string>('')
  const searchParams = useSearchParams()

  const handleSelect = (challengeThemeId?: string | number) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    if (challengeThemeId) {
      params.set('challengeThemeId', String(challengeThemeId))
    } else {
      params.delete('challengeThemeId')
    }

    setCurrentTheme(challengeThemeId ? String(challengeThemeId) : '')

    if (onServer) {
      replace(`${pathname}?${params.toString()}`)
    } else {
      window.history.replaceState(null, '', `?${params.toString()}`)
    }
  }

  return (
    <>
      <div className="hidden lg:inline-flex gap-3">
        <div
          className={`${isEmpty(currentTheme) ?
            'bg-gray-800 text-white' :
            'bg-white'} px-3 py-2 rounded-full border text-sm justify-center items-center cursor-pointer hover:bg-gray-800 hover:text-white transition-all`}
          onClick={() => handleSelect()}
        >
          <span>All Themes</span>
        </div>
        {
          map(data, (challengeTheme, index) => (
            <div
              key={`${challengeTheme.id}_${index}`}
              className={`${currentTheme === String(challengeTheme.id) ?
                'bg-gray-800 text-white' :
                'bg-white'} px-3 py-2 rounded-full border text-sm inline-flex justify-center items-center cursor-pointer hover:bg-gray-800 hover:text-white transition-all`}
              onClick={() => handleSelect(challengeTheme.id)}
            >
              <span>Theme {index + 1}</span>
            </div>
          ))
        }
      </div>
      <select
        onChange={(e) => handleSelect(e.target.value)}
        className="block lg:hidden bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5">
        <option value="">All Themes</option>
        {
          map(data, (challengeTheme, index) => (
            <option key={`${challengeTheme.id}_${index}`}
                    value={challengeTheme.id}>
              Theme {index + 1}
            </option>
          ))
        }
      </select>
    </>
  )
}

export default ChallengeThemeSelection
